import { Helper } from '@/mixin/helper'
import { Cookie } from '@/mixin/local-cookie'
import store from '@/state/store'
export default [
  {
    path: '/login/',
    name: 'Login',
    component: () => import(/* webpackChunkName: "auth" */ '@/router/views/account/login'),
    meta: {
      guestPage: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        // hide freshchat in login page
        const fcId = document.getElementById('custom_fc_button')
        if (fcId) {
          fcId.style = 'display: none'
        }
        // If the user is already logged in
        if (store.state.identity.whoami !== null) {
          // Redirect to the home page instead
          Helper.methods.userLogging('Login', _)
          window.location.href = '/'
        } else {
          if (localStorage.getItem('domainName') !== null) {
            // Prevent local development cannot go to login
            if (localStorage.getItem('domainName') == window.location.host) {
              return next()
            }

            const domainNameExpired = localStorage.getItem('domainNameExpired')
            if (domainNameExpired !== undefined && Date.now() >= domainNameExpired) {
              return next()
            }
            window.location.href = `${window.location.protocol}//${localStorage.getItem(
              'domainName'
            )}/login`
          } else {
            next()
          }
        }
      },
    },
  },
  {
    path: '/forgotpassword/',
    name: 'Forgot Password',
    component: () =>
      import(/* webpackChunkName: "auth" */ '@/router/views/account/forgotpassword/email'),
    meta: {
      beforeResolve(_, routeFrom, next) {
        // hide freshchat
        const fcId = document.getElementById('custom_fc_button')
        if (fcId) {
          fcId.style = 'display: none'
        }
        next()
      },
    },
  },
  {
    path: '/forgotpassword/verification',
    name: 'OTP Verification',
    component: () =>
      import(/* webpackChunkName: "auth" */ '@/router/views/account/forgotpassword/verification'),
    meta: {
      beforeResolve(_, routeFrom, next) {
        // hide freshchat
        const fcId = document.getElementById('custom_fc_button')
        if (fcId) {
          fcId.style = 'display: none'
        }
        next()
      },
    },
  },
  {
    path: '/forgotpassword/reset',
    name: 'Reset Password',
    component: () =>
      import(/* webpackChunkName: "auth" */ '@/router/views/account/forgotpassword/resetpassword'),
    meta: {
      beforeResolve(_, routeFrom, next) {
        // hide freshchat
        const fcId = document.getElementById('custom_fc_button')
        if (fcId) {
          fcId.style = 'display: none'
        }
        next()
      },
    },
  },
  {
    path: '/forgotpassword/result',
    name: 'Password Changed',
    component: () =>
      import(/* webpackChunkName: "auth" */ '@/router/views/account/forgotpassword/result'),
    meta: {
      beforeResolve(_, routeFrom, next) {
        // hide freshchat
        const fcId = document.getElementById('custom_fc_button')
        if (fcId) {
          fcId.style = 'display: none'
        }
        next()
      },
    },
  },
  {
    path: '/authenticate/:auth',
    name: 'auth',
    mixins: [Helper],
    meta: {
      guestPage: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        localStorage.removeItem('fcmToken')
        localStorage.removeItem('lastTokenTime')
        // If the user is already logged in
        if (store.state.identity.whoami !== null) {
          // Redirect to the home page instead
          next({ name: 'Dashboard' })
        } else {
          // Check Auth Token
          if (_.params.auth !== null) {
            store.dispatch('identity/logout').then(() => {
              Cookie.setLocalCookie('resource', _.params.auth, 'Session', '/')
              localStorage.setItem('domainName', window.location.host)
              Helper.methods.userLogging('Login', _)

              window.location.href = '/?isLoginSuccess=true'
            })
          } else {
            // Continue to the login page
            next({ name: 'Login' })
          }
        }
      },
    },
  },
  {
    path: '/logout/',
    name: 'logout',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Logout', _)
        localStorage.removeItem('token')
        localStorage.removeItem('wsToken')
        localStorage.removeItem('domainName')
        localStorage.removeItem('domainNameExpired')
        localStorage.removeItem('payload')
        localStorage.removeItem('fcmToken')
        localStorage.removeItem('lastTokenTime')
        localStorage.removeItem('activePopups')
        const cookies = Cookie.getLocalCookie()
        // if the token is set locally (HttpOnly = false) then the token will detected
        if (cookies.resource) {
          Cookie.setLocalCookie('resource', '', new Date().toString())
          return next({ name: 'Login' })
        }

        // if there is no token locally and the user logged in (this exactly from cookie)
        // then revoke token via api
        if (store.state.identity.whoami != null) {
          return store.dispatch('identity/logout').then(() => {
            next({ name: 'Login' })
          })
        }

        // default action for exisiting localStorage token
        next({ name: 'Login' })
      },
    },
  },
  {
    path: '/404/',
    name: '404',
    component: require(/* webpackChunkName: "other" */ '@/router/views/utility/404').default,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
]
